var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Chart',{ref:"chart",attrs:{"chartData":_vm.chartData,"width":_vm.width ? _vm.width - 50 : _vm.width,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }